import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino.js";
import { useDispatch } from "react-redux";
import { setHitGames } from "../../store/gamesSlice.js";
import GamesItems from "../mui/games_items/GamesItems.jsx";
import { TEST_MODE } from "../../store/enums.js";

export default function HitGames() {
  const dispatch = useDispatch();
  const games = useAppSelector((state) => state.games.hitGames);
  const currency = useAppSelector((state) => state.user.currency);

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (TEST_MODE) return;

    setLoader(true);
    API_CASINO.list
      .hit({ currency })
      .then((e) => {
        const list = e.data.list;
        dispatch(setHitGames(list));
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, []);

  return <GamesItems games={games} loader={loader} noGames />;
}
